import log from "loglevel";

export const logger = log.getLogger("@skydio/skybus");
logger.setLevel(log.levels.ERROR);

export function setLogLevel(level: log.LogLevelDesc) {
  logger.setLevel(level);
}
